import { Routes } from '@angular/router';
import { CollectionService } from './collections/services/collection.service';
import { HomeService } from './home/services/home.service';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { RequestService } from './requests/services/request.service';
import { authGuard } from './routing/auth.guard';
import { FileUploadService } from './uploads/services/file-upload.service';
import { UploadService } from './uploads/services/upload.service';
import { VirtualEnvironmentService } from './virtual-environments/services/virtual-environment.service';

export const routes: Routes = [
  {
    path: '',
    component: SimpleLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () => import('./landing/landing.component').then(m => m.LandingComponent),
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      {
        path: 'home',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
        canActivate: [authGuard],
        providers: [HomeService]
      },
      {
        path: 'data-collections',
        loadChildren: () => import('./collections/collections.routes').then(m => m.routes),
        canLoad: [authGuard],
        canActivateChild: [authGuard],
        providers: [CollectionService]
      },
      {
        path: 'data-utilization',
        loadChildren: () => import('./requests/requests.routes').then(m => m.routes),
        canLoad: [authGuard],
        canActivateChild: [authGuard],
        providers: [RequestService]
      },
      {
        path: 'data-uploads',
        loadChildren: () => import('./uploads/uploads.routes').then(m => m.routes),
        canLoad: [authGuard],
        canActivateChild: [authGuard],
        providers: [UploadService, FileUploadService]
      },
      {
        path: 'terms-of-use',
        loadComponent: () => import('./terms-of-use/terms-of-use.component').then(m => m.TermsOfUseComponent),
        canLoad: [authGuard],
        canActivateChild: [authGuard]
      },
      {
        path: 'app-info',
        loadComponent: () => import('./app-info/app-info.component').then(m => m.AppInfoComponent),
        canLoad: [authGuard],
        canActivateChild: [authGuard]
      },
      {
        path: 'virtual-environment',
        loadChildren: () => import('./virtual-environments/virtual-environments.routes').then(m => m.routes),
        canLoad: [authGuard],
        canActivateChild: [authGuard],
        providers: [VirtualEnvironmentService]
      },
      {
        path: 'virtual-env',
        redirectTo: 'virtual-environment'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
